/* @flow */

export const UPDATE_CONSIGNEE_STATUS_REQUEST = 'UPDATE_CONSIGNEE_STATUS_REQUEST';
export const UPDATE_CONSIGNEE_STATUS_SUCCESS = 'UPDATE_CONSIGNEE_STATUS_SUCCESS';
export const UPDATE_CONSIGNEE_STATUS_FAILURE = 'UPDATE_CONSIGNEE_STATUS_FAILURE';

export function success(payload) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_CONSIGNEE_STATUS_SUCCESS,
      payload,
    });
  };
}

export function failure(resource) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_CONSIGNEE_STATUS_FAILURE,
      payload: resource,
    });
  };
}

export default function updateConsigneeStatus(params) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_CONSIGNEE_STATUS_REQUEST,
      payload: params,
    });
  };
}
